<template>
  <stock-list :is-stock-status="2"></stock-list>
</template>

<script>
import StockList from './components/StockList'
export default {
  name: 'StockOut',
  components: {
    StockList
  }
}
</script>
